import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export const RubricSkeleton = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {[1, 2, 3].map((index) => (
                <Card key={index} className="shadow-sm">
                    <div className="p-5 space-y-4">
                        {/* Header */}
                        <div className="flex items-start justify-between gap-3">
                            <div className="flex items-start gap-3 flex-1 min-w-0">
                                <Skeleton className="h-10 w-10 rounded-lg flex-shrink-0" />
                                <div className="flex-1 min-w-0 space-y-2">
                                    <Skeleton className="h-5 w-3/4" />
                                    <Skeleton className="h-4 w-1/3" />
                                </div>
                            </div>
                            <Skeleton className="h-8 w-36 rounded-md" />
                        </div>

                        {/* Grid Skeleton */}
                        <div className="rounded-lg border border-border overflow-hidden bg-muted/30">
                            <div className="grid grid-cols-3 divide-x divide-border">
                                <div className="h-11 flex items-center justify-center">
                                    <Skeleton className="h-6 w-12" />
                                </div>
                                <div className="h-11 flex items-center justify-center">
                                    <Skeleton className="h-6 w-8" />
                                </div>
                                <div className="h-11 flex items-center justify-center">
                                    <Skeleton className="h-6 w-14" />
                                </div>
                            </div>
                            <div className="border-t border-border" />
                            <div className="grid grid-cols-3 divide-x divide-border">
                                <div className="h-11 flex items-center justify-center">
                                    <Skeleton className="h-6 w-8" />
                                </div>
                                <div className="h-11 flex items-center justify-center">
                                    <Skeleton className="h-6 w-12" />
                                </div>
                                <div className="h-11 flex items-center justify-center">
                                    <Skeleton className="h-6 w-10" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    );
};